export default class ExamPartResult {
    static fromData(data) {
        if (!data) {
            return;
        }

        const result = new ExamPartResult();
        result.id = data.id;
        result.description = data.description;
        result.status = data.status;
        result.note = data.note;
        result.createdAt = data.createdAt;
        result.updatedAt = data.updatedAt;

        return result;
    }

    serialize() {
        return {
            id: this.id,
            status: this.status,
            note: this.note,
        };
    }
}
